module.exports = __webpack_public_path__ + "static/IPhone_App_Wizard_02-252974c3d39dac8bbd842dd5129dee55.png";